module.exports = __webpack_public_path__ + "static/WSC_Group_2019_Individual_Income_Tax_Return_Checklist-56e00461faa5a94a8a3cc6ccfec4a891.pdf";